export enum FirebaseCollection {
    PROVIDER = "staff",
    CLINIC = "clinic",
    PATIENT = "patients",
    OPERATING_HOUR = "operatingHours",
    VIRTUAL_OPERATING = "virtualOperatingHours",
    GENERAL_SETTING = "generalSettings",
    COUNTER = "counters",
    USER = "users",
}
